export default "__VITE_ASSET__ae108347__"